import { AnyAction } from "redux";
import { FindById, Update } from "../../../announcements";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { AnnouncementsAdapter } from "../../../../adapter/announcements -adapter";

export const FETCH_UPDATE_ANNOUNCEMENT_REQUEST =
  "FETCH_UPDATE_ANNOUNCEMENT_REQUEST";
export const FETCH_UPDATE_ANNOUNCEMENT_SUCCESS =
  "FETCH_UPDATE_ANNOUNCEMENT_SUCCESS";
export const FETCH_UPDATE_ANNOUNCEMENT_FAILURE =
  "FETCH_UPDATE_ANNOUNCEMENT_FAILURE";
export const SET_UPDATE_ANNOUNCEMENT = "SET_UPDATE_ANNOUNCEMENT";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchUpdateAnnouncementRequest = () => {
  return {
    type: FETCH_UPDATE_ANNOUNCEMENT_REQUEST,
  };
};

const fetchUpdateAnnouncementSuccess = (
  data: any
): ActionPagination<Result<any>> => {
  return {
    type: FETCH_UPDATE_ANNOUNCEMENT_SUCCESS,
    payload: data,
  };
};

const fetchUpdateAnnouncementFailure = (error: any) => {
  return {
    type: FETCH_UPDATE_ANNOUNCEMENT_FAILURE,
    payload: error,
  };
};

export const setUpdateAnnouncement = (data: any) => {
  return {
    type: SET_UPDATE_ANNOUNCEMENT,
    payload: data,
  };
};

export const update = (id: string, data: any) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUpdateAnnouncementRequest());
    try {
      const response = await Update(id, data);
      dispatch(
        fetchUpdateAnnouncementSuccess(
          Adapter.from(response.data).to((value) =>
            new AnnouncementsAdapter(value).adapt()
          )
        )
      );
    } catch (error: any) {
      dispatch(fetchUpdateAnnouncementFailure(error.message));
    }
  };
};

export const findById = (id: string) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUpdateAnnouncementRequest());
    try {
      const response = await FindById(id, "fields=*.*.*");
      dispatch(
        setUpdateAnnouncement(new AnnouncementsAdapter(response.data).adapt())
      );
    } catch (error: any) {
      dispatch(fetchUpdateAnnouncementFailure(error.message));
    }
  };
};
